import { React, useEffect } from "react";

// Functions
import getParts from "../functions/get-parts";

// ------- Styles -------

const GetAllPartsNames = ({retrievePartsNamesList}) => {

  //Special handling to use localhost SAM API if running locally via npm start(make run)
  const getPartsApiUrl =
    process.env.NODE_ENV !== "development"
      ? "https://api." + process.env.NEXT_PUBLIC_DOMAIN + "/admin-parts"
      : process.env.NEXT_PUBLIC_USER_API_URL_LOCAL_SAM + "/admin-parts";

  useEffect(() => {
    getParts(getPartsApiUrl).then((data) => {
      if (data["message"] === "Dumping all parts") {

        // Extract just name and assemble for autocomplete component
        let nameList = []
        data["parts"].map((part) => {
          nameList.push(
            {
              label: `${part['Brand']}: ${part['ID']}`,
              id: part['ID'],
              part: part
            }
          )
        });

        nameList.push(
          {
            label: '',
            id: '',
            part: ''
          }
        )

        retrievePartsNamesList(nameList)
      }
    });
  }, []);
  return (
    <>
    </>
  );
};

export default GetAllPartsNames;
